/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ values: NonNullable<unknown> }} Ui_Laps_Recovery_Per_IntervalInputs */

const en_ui_laps_recovery_per_interval = /** @type {(inputs: Ui_Laps_Recovery_Per_IntervalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.values} bpm per interval`)
};

const de_ui_laps_recovery_per_interval = /** @type {(inputs: Ui_Laps_Recovery_Per_IntervalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.values} bpm pro Intervall`)
};

/**
* | output |
* | --- |
* | "{values} bpm per interval" |
*
* @param {Ui_Laps_Recovery_Per_IntervalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_recovery_per_interval = /** @type {((inputs: Ui_Laps_Recovery_Per_IntervalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Recovery_Per_IntervalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_recovery_per_interval(inputs)
	return de_ui_laps_recovery_per_interval(inputs)
});